export default [
  'calendar',
  'customer',
  'sales-cases',
  'shipping-records',
  'km',
  'report',
  'form-quotation',
  'form-cost',
  'form-margin',
  'form-order',
  'form-goods',
  'form-lading',
  'form-invoice',
  'form-warehouse',
  'UserGroup',
  'Role',
  'Zone',
  'Industry',
  'Trade',
  'WorkNature',
  'ProgressStatus',
  'ProjectProgress',
  'NewsType',
  'FilePropertyValue',
  'FileProperty',
  'ManageAccount',
  'UserCompanyInfo',
  'online-repair-service',
  'online-repair-tektro',
  'parts-base',
  'shipping-records',
  // new-admin
  'new-admin',
  // 以下項目置底原因為其他功能子route中有出現其名稱
  // 若不置底，在依序比對route時，可能誤判所在功能tab
  'news',
  'work-log',
  'product',
  'media-cloud'
];


// WEBPACK FOOTER //
// ./src/commonJS/funcTabRouteList.js